import styled from 'styled-components';
import Icon from '../../assets/images/lightbulb-icon.svg';

const LightbulbIcon = styled.span`
  background: url(\"${Icon}\") no-repeat left center;
  background-size: 42px 41px;
  display: inline-block;
  position: relative;
  width: 42px;
  height: 41px;
`;

export default LightbulbIcon;
